var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"hive",attrs:{"viewBox":_vm.viewbox,"xmlns":"http://www.w3.org/2000/svg"}},[_c('hex',{staticClass:"center",attrs:{"letter":_vm.center,"height":_vm.h,"coords":_vm.centerCoords}}),_vm._l((_vm.others),function(letter,index){return _c('hex',{key:index,attrs:{"letter":letter,"height":_vm.h,"coords":_vm.otherCoords[index]}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }